import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import qmsReducer from "./qmsSlice";
import qmsFolderStructureReducer from "./qmsFolderStructureSlice";
import themeReducer from "./themeSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  qms: qmsReducer,
  qmsFolderStructure: qmsFolderStructureReducer,
  theme: themeReducer,
});

export default rootReducer;
